import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=35b570eb&"
import script from "./CreateUser.vue?vue&type=script&lang=ts&"
export * from "./CreateUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b570eb')) {
      api.createRecord('35b570eb', component.options)
    } else {
      api.reload('35b570eb', component.options)
    }
    module.hot.accept("./CreateUser.vue?vue&type=template&id=35b570eb&", function () {
      api.rerender('35b570eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-management/CreateUser.vue"
export default component.exports